/** Vite `VITE_*` — 빌드 시 고정. 변경 후 dev 서버 재시작 필요. */

function envFlag(v: string | undefined): boolean {
  if (v == null || v === '') return false;
  const s = String(v).trim().toLowerCase();
  return s === '1' || s === 'true' || s === 'yes' || s === 'on';
}

export const MINIONS_UI = {
  /** 패턴·상태 패널 열기·내용 비활성 (상단「패턴」탭은 흐리게 유지) */
  disablePattern: envFlag(import.meta.env.VITE_MINIONS_DISABLE_PATTERN),
  /** 내역·검증 패널 열기·내용 비활성 (상단「내역」탭은 흐리게 유지) */
  disableHistory: envFlag(import.meta.env.VITE_MINIONS_DISABLE_HISTORY),
  /** 1/true — 마운트 시 패턴·내역 드롭다운을 펼친 상태로 시작 */
  drawerStartOpen: envFlag(import.meta.env.VITE_MINIONS_DRAWER_START_OPEN),
} as const;
